export const queryKeys = {
  companies: {
    getCompaniesList: "getCompaniesList",
  },
  dashboard: {
    getDashboardTasksList: "getDashboardTasksList",
  },
  handbooks: {
    getHandbooksList: "getHandbooksList",
    getHandbookLink: "getHandbookLink",
  },
  levels: {
    getLevelsList: "getLevelsList",
  },
  tasks: {
    getTasksList: "getTasksList",
  },
  ranking: {
    getRankingList: "getRankingList",
  },
  subtasks: {
    getSubtaskDetails: "getSubtaskDetails",
  },
  tutorials: {
    getTutorialProgressDetails: "getTutorialProgressDetails",
  },
  unlockedTutorials: {
    getUnlockedTutorialsList: "getUnlockedTutorialsList",
  },
  user: {
    getUser: "getUser",
  },
} as const;
